/**
 * Collection of event names, to be used as a standard across Javascript based Ads platform projects
 *
 * Function naming convention:
 * get-{domain}-{domainDesc}-event
 *
 * domain: [Tracking, NutsUI, NutsJSClient]
 * domainDesc: [CacheHit, CacheResponseReceived, etc.]
 *
 * Event naming convention:
 * ebay-ads-{function-name-in-lowercase-without-get}-{uniqueIdentifier}
 *
 * uniqueIdentifier: [placementId, url, docId]
 *
 * Note:
 * - Can be used both on Client Side and Server side
 * - Please mention the expected data to be returned in the event
 */

module.exports = {
    // Tracking based events

    // Contains the string URL of the napkin ticket
    getTrackingCacheHitURLEvent: (placementId) => `ebay-ads-tracking-cache-hit-url-event-${placementId}`,
    // Contains the napkin responses HTTP code
    getTrackingHTTPCodeEvent: (placementId) => `ebay-ads-tracking-http-code-event-${placementId}`,
    // Contains error messages, if any
    getTrackingErrorMessagesEvent: (placementId) => `ebay-ads-tracking-error-messages-event-${placementId}`,
    // Contains Array of Placement Ids for which napkin response was returned
    getTrackingPlacementIdsEvent: (placementId) => `ebay-ads-tracking-placement-ids-event-${placementId}`,

    // Nuts UI Based Events
    // Contains napkin's response
    getNutsUICacheResponseReceivedEvent: (cacheURL) => `ebay-ads-nuts-ui-cache-response-received-event-${cacheURL}`,
    // Contains no data
    getNutsUIResponseRenderedEvent: (docId) => `ebay-ads-nuts-ui-response-rendered-event-${docId}`,
    // Lazy Module fetch call's response
    getNutsUILazyModuleResponseReceivedEvent: (placementId) => `ebay-ads-nuts-ui-lazy-module-response-received-event-${placementId}`,
    // Contains no data
    getNutsUIResourceLoadedEvent: (url) => `ebay-ads-nuts-ui-resource-loaded-event-${url}`,

    // NutsJS Based Events
    // contains deli's response
    getNutsJSClientResponseReceivedEvent: (placementId) => `ebay-ads-nuts-js-client-response-received-event-${placementId}`
};
